import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { vehiclesListSearchSchema } from '&/features/vehicles/lib/vehicles-list-search';

export const Route = createFileRoute('/_authenticated/vehicles')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('vehicles:list')) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/vehicles-page')),
  staticData: { titleKey: 'vehicles' },
  // The list's tab / filters / search / page / sort live in the URL (SWOOP-230) so a Back from a
  // vehicle profile restores the list. Every field is optional and coerced, so this never rejects.
  validateSearch: (search) => vehiclesListSearchSchema.parse(search),
});
